export default __webpack_public_path__ + "static/media/processing-hourglass.2f48f9af.svg";